import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';

import { 
    Box, Grid,
} from '@material-ui/core';
import Dialog from '../../../commonModules/interface/Dialog';
import InputText from '../../../commonModules/interface/form-input-inline';
// import InputText from '../../common/Form';
// import Dialog from '../../common/Dialog';


class SocietyForm extends Component {
    state = { 
        society:{
            society_name: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_name : "",
            society_address: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_address : "",
            society_address2: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_address2 : "",
            society_zipcode: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_zipcode : "",
            society_city: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_city : "",
            society_country: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_country : "",
            society_phone: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_phone : "",
            society_phone2: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_phone2 : "",
            society_email: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_email : "",
            society_website: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_website : "",
            society_ifu: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_ifu : "",
            society_matricule: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_matricule : "",
            society_bottom: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_bottom : "",
            society_dg: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_dg : "",
            society_capital: !isEmpty(this.props.SOCIETY) ? this.props.SOCIETY.society_capital : "",
        },
        
        errors:{},
    }

    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        
        this.setState({
            ...this.state,
            society:{
                ...this.state.society,
                [name]: value

            }
        })
    }
    
    validate = () => {
        let required = [,
            "society_name",
            "society_address",
            // "society_address2",
            // "society_zipcode",
            "society_city",
            "society_country",
            "society_phone",
            // "society_phone2",
            "society_email",
            "society_website",
            "society_ifu",
            "society_matricule",
            "society_bottom",
            "society_dg",
            "society_capital"
        ]
        
        let noError = true
        let errors = {}
        required.map(field => {
            if(!this.state.society[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return noError
    }
    
    handleSubmit = async () => {
        if(this.validate()){
            let data = {}
            if (this.props.SOCIETY) {
                data = Object.assign(data, this.props.SOCIETY)
            }
            data.society_name = this.state.society.society_name
            data.society_address = this.state.society.society_address
            data.society_address2 = this.state.society.society_address2
            data.society_zipcode = this.state.society.society_zipcode
            data.society_city = this.state.society.society_city
            data.society_country = this.state.society.society_country
            data.society_phone = this.state.society.society_phone
            data.society_phone2 = this.state.society.society_phone2
            data.society_email = this.state.society.society_email
            data.society_website = this.state.society.society_website
            data.society_ifu = this.state.society.society_ifu
            data.society_matricule = this.state.society.society_matricule
            data.society_bottom = this.state.society.society_bottom
            data.society_dg = this.state.society.society_dg
            data.society_capital = parseFloat(this.state.society.society_capital)
            
            
            console.log('====================================');
            console.log({data});
            console.log('====================================');
            
            // if(this.props.SOCIETY){
            //     await this.props.updateSociety(data)
            // } else {
                await this.props.newSociety(data)  
            // }

            if(this.props.STATE.society.error){
                console.log('====================================');
                console.log("ERROR", this.props.STATE.society );
                console.log('====================================');
                toast.error(`Un problème est survenu: ${this.props.STATE.society.error}`)
            } else {
                !this.props.SOCIETY && toast.success("La société a été créée avec succès")
                this.props.SOCIETY && toast.success("La société a été modifiée avec succès")
                this.props.handleClose()
            }
        } else {
            toast.error("Le formulaire contient des erreurs")
        }
    }

    render() {
        console.log('====================================');
        console.log(this.state.society, this.props.SOCIETY);
        console.log('====================================');
        return (

            <Dialog
                close={this.props.handleClose}
                title="Infos Entreprise"
                submitAction={this.handleSubmit}
                maxWidth="md"
                block={true}
            >
                <Box p={2} >
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_name" 
                                id="society_name" 
                                value={this.state.society.society_name} 
                                label="Nom" 
                                placeholder="Nom société" 
                                error={this.state.errors.society_name} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_address" 
                                id="society_address" 
                                value={this.state.society.society_address} 
                                label="Adresse" 
                                error={this.state.errors.society_address} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_address2" 
                                id="society_address2" 
                                value={this.state.society.society_address2} 
                                label="Complément d'adresse" 
                                error={this.state.errors.society_address2} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_zipcode" 
                                id="society_zipcode" 
                                value={this.state.society.society_zipcode} 
                                label="Code Postal" 
                                error={this.state.errors.society_zipcode} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_city" 
                                id="society_city" 
                                value={this.state.society.society_city} 
                                label="Ville" 
                                error={this.state.errors.society_city} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_country" 
                                id="society_country" 
                                value={this.state.society.society_country} 
                                label="Pays" 
                                error={this.state.errors.society_country} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_phone" 
                                id="society_phone" 
                                value={this.state.society.society_phone} 
                                label="Téléphone 1" 
                                error={this.state.errors.society_phone} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_phone2" 
                                id="society_phone2" 
                                value={this.state.society.society_phone2} 
                                label="Téléphone 2" 
                                error={this.state.errors.society_phone2} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_email" 
                                id="society_email" 
                                value={this.state.society.society_email} 
                                label="Email" 
                                error={this.state.errors.society_email} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_website" 
                                id="society_website" 
                                value={this.state.society.society_website} 
                                label="Site Web" 
                                error={this.state.errors.society_website} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_ifu" 
                                id="society_ifu" 
                                value={this.state.society.society_ifu} 
                                label="IFU" 
                                error={this.state.errors.society_ifu} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_matricule" 
                                id="society_matricule" 
                                value={this.state.society.society_matricule} 
                                label="Immatriculation Registre du Commerce" 
                                error={this.state.errors.society_matricule} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_dg" 
                                id="society_dg" 
                                value={this.state.society.society_dg} 
                                label="Nom Gérant" 
                                placeholder="M. ..."
                                error={this.state.errors.society_dg} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="society_capital" 
                                id="society_capital" 
                                value={this.state.society.society_capital} 
                                label="Capital Social" 
                                error={this.state.errors.society_capital} 
                                onChange={this.handleChange}
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputText
                                required
                                name="society_bottom" 
                                id="society_bottom" 
                                value={this.state.society.society_bottom} 
                                label="Pied de page" 
                                error={this.state.errors.society_bottom} 
                                onChange={this.handleChange}
                                multiline
                                rows={4}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Dialog>
        );
    }
}

export default SocietyForm;




